import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { ApiService } from '../../utils/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { LoaderService } from 'src/app/utils/services/loader.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-disclaimer-list',
  templateUrl: './disclaimer-list.component.html',
  styleUrls: ['./disclaimer-list.component.scss']
})
export class DisclaimerListComponent implements OnInit {

  private category: string;
  dtOptions: DataTables.Settings = {};
  public allData: any[]=[];
  private isDtInitialized: boolean = false;
  public addCatName: string;
  public addCatRoute: string;
  public editCatRoute: string;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;

  constructor(private router: Router, private apiService: ApiService, private toastr: ToastrService ,private LoaderService:LoaderService) {}

  

  ngOnInit(): void {
    this.LoaderService.showLoader()
    this.category = this.router.url.split('/')[1];
    // this.content_id = this.router.url.split('/')[2];
    // console.log(this.category);
    if(this.category === "disclaimer-list") {
      this.addCatName = 'Add Disclaimer';
      this.addCatRoute = '/disclaimer';
      this.editCatRoute = '/edit-disclaimer';
    } 

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
    };
    this.showItem();
  }

  async showItem() {
    this.LoaderService.showLoader()

    console.log('hi')
    const that = this;
    let catTypeListApi: any;
    if(this.category === "disclaimer-list") {
      catTypeListApi = this.apiService.disclaimerList();
    } 
    await catTypeListApi.subscribe((resp: any) => {
      console.log(resp.data);
      that.allData.push( resp.data[0]);
      this.LoaderService.hideLoader()

      if (this.isDtInitialized) {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next();
          this.LoaderService.hideLoader()

        });
      } else {
        this.isDtInitialized = true;
        this.dtTrigger.next();
        this.LoaderService.hideLoader()

      }
    });
  }

  async deleteItem(id, type) {
    this.LoaderService.showLoader();
  
    if (id == undefined || id == '') {
      this.toastr.error('User Id is Invalid');
      return false;
    }
  
    // Replace confirm with SweetAlert2 for confirmation dialog
    if (id != undefined && id != '') {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: 'You won\'t be able to restore this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it'
      });
  
      if (result.isConfirmed) {
        // Handle Internal category deletion
        if (type.split(' ')[0] === 'Internal') {
          let catTypeInDltApi: any;
          if (this.category === "news-list") {
            catTypeInDltApi = this.apiService.deleteInternalNewsById(id);
          } else if (this.category === "gmp-list") {
            catTypeInDltApi = this.apiService.deleteInternalGmpById(id);
          } else if (this.category === "regulatory-guidelines-list") {
            catTypeInDltApi = this.apiService.deleteInternalGuidelinesById(id);
          } else if (this.category === "business-list") {
            catTypeInDltApi = this.apiService.deleteInternalBusinessById(id);
          } else if (this.category === "products-services-list") {
            catTypeInDltApi = this.apiService.deleteInternalProductById(id);
          }
  
          await catTypeInDltApi.subscribe((result: any) => {
            if (result.success) {
              this.LoaderService.hideLoader();
              this.toastr.success(result.message);
              this.showItem();
            } else {
              this.LoaderService.hideLoader();
              this.toastr.error(result.message);
            }
          });
        } 
        
        // Handle External category deletion
        else if (type.split(' ')[0] === 'External') {
          let catTypeExDltApi: any;
          if (this.category === "news-list") {
            catTypeExDltApi = this.apiService.deleteExternalNewsById(id);
          } else if (this.category === "gmp-list") {
            catTypeExDltApi = this.apiService.deleteExternalGmpById(id);
          } else if (this.category === "regulatory-guidelines-list") {
            catTypeExDltApi = this.apiService.deleteExternalGuidelinesById(id);
          } else if (this.category === "business-list") {
            catTypeExDltApi = this.apiService.deleteExternalBusinessById(id);
          } else if (this.category === "products-services-list") {
            catTypeExDltApi = this.apiService.deleteExternalProductById(id);
          }
  
          await catTypeExDltApi.subscribe((result: any) => {
            if (result.success) {
              this.LoaderService.hideLoader();
              this.toastr.success(result.message);
              this.showItem();
            } else {
              this.LoaderService.hideLoader();
              this.toastr.error(result.message);
            }
          });
        }
      } else {
        this.LoaderService.hideLoader(); // If the user cancels the deletion
      }
    } else {
      this.LoaderService.hideLoader(); // If ID is invalid
    }
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
}

